import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SHOWCASE_STORIES_FEATURE_NAME } from './feature-name.constant';
import { ShowcaseStoriesState } from './showcase-stories.state';

const selectShowcaseStoriesState = createFeatureSelector<ShowcaseStoriesState>(SHOWCASE_STORIES_FEATURE_NAME);
export const selectShowcaseStoriesPhotosLayout = createSelector(selectShowcaseStoriesState, state => state.layout);
export const selectShowcaseStoriesPhotosLoading = createSelector(selectShowcaseStoriesState, state => state.loading);
export const selectShowcaseStoriesPhotos = createSelector(selectShowcaseStoriesState, state => state.photos);
